import * as React from 'react';
import * as PropTypes from 'prop-types';

const NCModal = (props) => {
  const { showModal, title, description, buttons } = props;
  return (
    <React.Fragment>
      {showModal ? (
        <React.Fragment>
          <div className='focus:outline-none fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none'>
            <div className='desktop:w-4/12 tablet:w-3/6 relative w-5/6 mx-auto my-6'>
              {/* content */}
              <div className='border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none min-h-[200px] p-4'>
                {/* header */}
                <div className='flex items-start justify-between'>
                  <h3 className='text-xl font-extrabold'>{title}</h3>
                </div>
                {/* body */}
                <div className='relative flex-auto py-4'>
                  <p className='text-sm font-light leading-5 text-left'>
                    {description}
                  </p>
                </div>
                {/* footer */}
                <div className='flex items-center justify-end'>
                  {buttons.map((item, key) => (
                    <button
                      key={item.title + `${key}`}
                      className='text-primary background-transparent focus:outline-none px-2 py-2 mb-1 mr-1 text-sm font-bold uppercase transition-all duration-150 ease-linear outline-none'
                      type='button'
                      onClick={item.callback}
                    >
                      {item.title}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className='fixed inset-0 z-40 bg-black opacity-50'></div>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};

NCModal.propTypes = {
  /**
   * Modal title
   */
  title: PropTypes.string,
  /**
   * Modal Description
   */
  description: PropTypes.string,
  /**
   * Buttons will show in modal
   * Pass the array object with title & callback function like: buttons={[{ title: 'cancel', callback: function}, {[title: 'ok', callback: function]}]}
   */
  buttons: PropTypes.array,
  /**
   * showModal default value: false
   * if showModal value is true then it will show up modal
   */
  showModal: PropTypes.bool
  // Here is the sample code for modal: <NCModal title="" description="" buttons={[{ title: 'cancel', callback: function}, {[title: 'ok', callback: function]}]} showModal={true/false}/>
};

export default NCModal;
